<template>
  <div class="fllow-account" data-sensors-exposure-event-name="Element_Exposure" data-sensors-exposure-property-caseId="fllow_wechat_official_account">
    <div class="left">
      <div class="icon"></div>
      <div class="text">
        <div class="title">关注天美贷微信公众号</div>
        <div class="info">享提额免息等更多福利</div>
      </div>
    </div>
    <div class="btn" data-sensors-click @click="fllowAccount">马上关注</div>
  </div>
</template>

<script>
import { copyToClipbord } from '@/assets/utils'
export default {
  props: {
    countDownInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    fllowAccount () {
      copyToClipbord('ct_tmd')
      this.$message('公众号已复制至剪切板，前往微信搜索关注吧')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.fllow-account {
  width: 10rem;
  height: 105px;
  background: rgba(0, 0, 0, 0.8);
  padding: 0 40px 0 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;

    .icon {
      width: 60px;
      height: 60px;
      background: url(./images/icon_fuli@2x.png) no-repeat center center;
      background-size: cover;
    }

    .text {
      margin-left: 16px;

      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: left;
        font-style: normal;
      }

      .info {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #AAAAAA;
        line-height: 33px;
        text-align: left;
        font-style: normal;
      }
    }
  }

  .btn {
    width: 120px;
    height: 36px;
    background: #FF4633;
    border-radius: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    font-style: normal;
  }
}
</style>